// src/app/core/api/sap-api-factories.ts

import { Configuration as BomApiConfiguration } from 'src/generated-clients/bom';
import { Configuration as ColourApiConfiguration } from 'src/generated-clients/colour';
import { Configuration as ConnectorApiConfiguration } from 'src/generated-clients/connector';
import { Configuration as ConstructionApiConfiguration } from 'src/generated-clients/construction';
import { Configuration as DesignApiConfiguration } from 'src/generated-clients/design';
import { Configuration as DocumentApiConfiguration } from 'src/generated-clients/document';
import { Configuration as EquipmentApiConfiguration } from 'src/generated-clients/equipment';
import { Configuration as FamilyTreeApiConfiguration } from 'src/generated-clients/familytree';
import { Configuration as InfoCodesApiConfiguration } from 'src/generated-clients/infocodes';
import { Configuration as ItemLogApiConfiguration } from 'src/generated-clients/itemlog';
import { Configuration as LongTextApiConfiguration } from 'src/generated-clients/longtext';
import { Configuration as MaterialApiConfiguration } from 'src/generated-clients/material';
import { Configuration as MaterialWhereUsedConfiguration } from 'src/generated-clients/material_whereused';
import { Configuration as MultiColourApiConfiguration } from 'src/generated-clients/multicolour';
import { Configuration as NotificationApiConfiguration } from 'src/generated-clients/notification';
import { Configuration as OrderApiConfiguration } from 'src/generated-clients/order';
import { Configuration as PartnerApiConfiguration } from 'src/generated-clients/partner';
import { Configuration as ProjectApiConfiguration } from 'src/generated-clients/project';
import { Configuration as TaskListApiConfiguration } from 'src/generated-clients/tasklist';
import { Configuration as UomApiConfiguration } from 'src/generated-clients/uom';
import { Configuration as UserMaterialApiConfiguration } from 'src/generated-clients/user_material';

import { SapApiModule } from 'src/app/modules/sap-api.module';

export function colourApiConfigurationFactory() {
  return new ColourApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_COLOUR_V_CDS`,
  });
}

export function connectorApiConfigurationFactory() {
  return new ConnectorApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_CONNECTOR_V_CDS`,
  });
}

export function constructionApiConfigurationFactory() {
  return new ConstructionApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_CONSTRUCTION_SRV`,
  });
}

export function designApiConfigurationFactory() {
  return new DesignApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_DESIGN_SRV`,
  });
}

export function familyTreeApiConfigurationFactory() {
  return new FamilyTreeApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_FAMILYTREE_SRV`,
  });
}

export function infoCodesApiConfigurationFactory() {
  return new InfoCodesApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_INFOCODES_SRV`,
  });
}

export function itemLogApiConfigurationFactory() {
  return new ItemLogApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_ITEMLOG_SRV`,
  });
}

export function notificationApiConfigurationFactory() {
  return new NotificationApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_NOTIFICATION_SRV`,
  });
}

export function orderApiConfigurationFactory() {
  return new OrderApiConfiguration({ basePath: `${SapApiModule.sapUrl}/YPM_ORDER_SRV` });
}

export function projectApiConfigurationFactory() {
  return new ProjectApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_PROJECT_SRV`,
  });
}

export function taskListApiConfigurationFactory() {
  return new TaskListApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_TASKLIST_SRV`,
  });
}

export function materialWhereUsedApiConfigurationFactory() {
  return new MaterialWhereUsedConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_MATERIAL_WHEREUSED_SRV`,
  });
}

export function documentApiConfigurationFactory() {
  return new DocumentApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_DOCUMENT_V_CDS`,
  });
}

export function partnerConfigurationFactory() {
  return new PartnerApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_PARTNER_V_CDS`,
  });
}

export function bomConfigurationFactory() {
  return new BomApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPLM_BOM_SRV`,
  });
}

export function multiColourConfigurationFactory() {
  return new MultiColourApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_MULTICOLOUR_V_CDS`,
  });
}

export function uomConfigurationFactory() {
  return new UomApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_UOM_V_CDS`,
  });
}

export function longTextConfigurationFactory() {
  return new LongTextApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_LONGTEXT_SRV`,
  });
}

export function userMaterialConfigurationFactory() {
  return new UserMaterialApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_USER_MATERIAL_AUTH_SRV`,
  });
}

export function materialDataSetConfigurationFactory() {
  return new MaterialApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPLM_MAT_SRV`,
  });
}

export function equipmentApiConfigurationFactory() {
  return new EquipmentApiConfiguration({
    basePath: `${SapApiModule.sapUrl}/YPM_CONSTRUCTION_V_CDS`,
  });
}
